import { SsoPassThruHttpClient } from "../../srm-sso-authentication/sso-pass-thru-http-client";
import { BtmReturnRequest, IBtmReturnRequestDto } from "../../../btm-returns/model/btm-return-request";

export const GetBtmReturnRequestByDeclarationIdHandler = async (httpClient: SsoPassThruHttpClient,
                                                                declarationId: string) => {
    return new BtmReturnRequest((await httpClient.get<{ returnRequestsData: IBtmReturnRequestDto }>(`/api/v3/return-request/declaration/${declarationId}`)).returnRequestsData);
};
